export default "__VITE_ASSET__9dbcf34e__"